module.exports = __webpack_public_path__ + "images/ab60ff9.png";